/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert between common units instantly — length, weight, temperature and more. Pick a category, enter a value, and get an accurate result as you type.`)
};

const es_uc_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte entre unidades comunes al instante — longitud, peso, temperatura y más. Elige una categoría, ingresa un valor y obtén un resultado preciso mientras escribes.`)
};

const de_uc_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnen Sie gängige Einheiten sofort um — Länge, Gewicht, Temperatur und mehr. Wählen Sie eine Kategorie, geben Sie einen Wert ein und erhalten Sie beim Tippen ein präzises Ergebnis.`)
};

const nl_uc_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converteer direct tussen veelgebruikte eenheden — lengte, gewicht, temperatuur en meer. Kies een categorie, voer een waarde in en krijg direct een nauwkeurig resultaat.`)
};

const fr_uc_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez entre les unités courantes instantanément — longueur, poids, température et plus. Choisissez une catégorie, entrez une valeur, et obtenez un résultat précis au fur et à mesure que vous tapez.`)
};

const it_uc_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti tra unità comuni istantaneamente — lunghezza, peso, temperatura e altro. Scegli una categoria, immetti un valore e ottieni un risultato accurato mentre digiti.`)
};

const pt_br2_uc_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta entre unidades comuns instantaneamente — comprimento, peso, temperatura e muito mais. Escolha uma categoria, digite um valor e obtenha um resultado preciso conforme você digita.`)
};

const pt_uc_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter entre unidades comuns instantaneamente — comprimento, peso, temperatura e muito mais. Escolha uma categoria, introduza um valor e obtenha um resultado preciso à medida que digita.`)
};

const ja_uc_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的な単位をすぐに変換 — 長さ、質量、温度など。カテゴリを選択し、値を入力すると、入力時に正確な結果が得られます。`)
};

const zh_uc_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_intro", locale)
	if (locale === "en") return en_uc_hub_intro(inputs)
	if (locale === "es") return es_uc_hub_intro(inputs)
	if (locale === "de") return de_uc_hub_intro(inputs)
	if (locale === "nl") return nl_uc_hub_intro(inputs)
	if (locale === "fr") return fr_uc_hub_intro(inputs)
	if (locale === "it") return it_uc_hub_intro(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_intro(inputs)
	if (locale === "pt") return pt_uc_hub_intro(inputs)
	if (locale === "ja") return ja_uc_hub_intro(inputs)
	return zh_uc_hub_intro(inputs)
};